module.exports = __webpack_public_path__ + "img/MAN.672cf67b.svg";